'use client'

import { selectIsLoggedIn, useAuthStore } from '@/stores/useAuthStore'

/** Cliente logado (cache da sessão na useAuthStore), pelo seletor único `selectIsLoggedIn`. */
export function useIsLoggedIn(): boolean {
    return useAuthStore(selectIsLoggedIn)
}
